import { createFileRoute, Outlet } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';

export const Route = createFileRoute('/settings')({
  component: SettingsComponent,
});

function SettingsComponent() {
  return (
    <AuthenticateRoute>
      <Outlet />
    </AuthenticateRoute>
  );
}
